import type { IGraphics, GraphicsStyle } from '../IRenderer';

/**
 * createGraphics — substrate-agnostic factory for solid-fill Graphics
 * surfaces.
 *
 * Phase H10 Arc λ.10 (2026-05-10): PhaserGraphics fallback removed.
 * PixiFactoriesRegistry wires the Pixi impl at boot. The `_scene`
 * parameter is retained for call-site compatibility (pre-λ.10b sweep);
 * λ.10b drops it entirely.
 */

type PixiFactory = (style?: GraphicsStyle) => IGraphics;

let pixiFactory: PixiFactory | null = null;

export function registerPixiGraphicsFactory(fn: PixiFactory): void {
  pixiFactory = fn;
}

export function createGraphics(_scene: unknown, style?: GraphicsStyle): IGraphics {
  if (!pixiFactory) {
    throw new Error('[createGraphics] Pixi factory not registered. Call registerAllPixiFactories() at boot.');
  }
  return pixiFactory(style);
}
